import {
  useSelectedNumberByVariableKey,
  useSelectedValueAttributeByKey,
  useSelectedValueByVariableKey,
} from '@k3/core'
import { ColorRepresentation } from 'three'
import { Keys } from './utlility/utils'
import {
  getValuesColor,
  isForbiddenValues,
  isMaxValuesPerVariable,
} from './isForbiddenValues'

export const useRoof = () => {
  const colorValues = useSelectedValueByVariableKey(Keys.ProfilColor.Variable)
  const forbiddenColorAmount = isMaxValuesPerVariable(
    Keys.ProfilColor.MaxValues,
    colorValues
  )
  const defaultColor =
    getValuesColor(Keys.ProfilColor.MaxValues, colorValues) || '#FFF'

  const color = forbiddenColorAmount
    ? (colorValues?.value as ColorRepresentation) || '#FFF'
    : (defaultColor as ColorRepresentation)

  const metalColor =
    ((useSelectedValueByVariableKey('metalColor')?.value ||
      color) as ColorRepresentation) || '#FFF'

  const roofMarqueeMetalColor =
    ((useSelectedValueByVariableKey('verticalMarqueeMetalColor')?.value ||
      color) as ColorRepresentation) || '#FFF'

  const glassDensity = useSelectedValueByVariableKey(
    Keys.Eindeckung.Variable
  )?.key

  const dockTile = useSelectedValueByVariableKey('dockTile')?.label

  const ledLight =
    ((useSelectedValueByVariableKey('ledLight')?.key === 'ja') as boolean) ||
    false

  const ledLightColor =
    (useSelectedValueByVariableKey('ledColor')?.value as string) || '#b97b12'

  const opacity =
    (useSelectedValueAttributeByKey(Keys.Eindeckung.Variable, 'opacity')
      ?.value as number) || 0

  const roughness =
    (useSelectedValueAttributeByKey(Keys.Eindeckung.Variable, 'roughness')
      ?.value as number) || 0

  const roofGlassDepth = useSelectedValueAttributeByKey(
    Keys.Eindeckung.Variable,
    'depth'
  )
    ? (useSelectedValueAttributeByKey(Keys.Eindeckung.Variable, 'depth')
        ?.value as number) / 10
    : 0

  const ledsOld =
    ((useSelectedValueByVariableKey('ledPer')?.label === '1'
      ? 1
      : 2) as number) || 2

  const leds =
    (useSelectedValueAttributeByKey('ledPer', 'wert')?.value as number) || 0
  const unit: number = ledLight ? (leds ? leds : ledsOld) : 0

  const hasCoverRotation =
    useSelectedValueByVariableKey('coverRotation') || false

  const coverRotation = (useSelectedValueByVariableKey('coverRotation')
    ?.value === '1' || false) as boolean

  const oldSlatAngle =
    ((useSelectedValueAttributeByKey('slatAngle', 'grad')?.value ===
      0) as boolean) || false
  const slatAngle = hasCoverRotation ? coverRotation : oldSlatAngle

  const slatMoveIn = useSelectedValueByVariableKey('slatMoveIn')?.value || 0

  const glasColor =
    ((useSelectedValueByVariableKey('glasColor')?.value ||
      '#FFF') as ColorRepresentation) || '#FFF'

  const frequenz =
    (useSelectedValueAttributeByKey(Keys.Eindeckung.Variable, 'frequenz')
      ?.value as number) || 0

  const amplitude =
    (useSelectedValueAttributeByKey(Keys.Eindeckung.Variable, 'amplitude')
      ?.value as number) || 0

  const roofCoverings = {
    glas: (glassDensity === isForbiddenValues(Keys.Eindeckung.Values.Glas) ||
      false) as boolean,
    poly: (glassDensity ===
      isForbiddenValues(Keys.Eindeckung.Values.Polycarbonat) ||
      false) as boolean,
    welle: (glassDensity === isForbiddenValues(Keys.Eindeckung.Values.Welle) ||
      false) as boolean,
    trapez: (glassDensity ===
      isForbiddenValues(Keys.Eindeckung.Values.Trapez) || false) as boolean,
    lamellen: (glassDensity ===
      isForbiddenValues(Keys.Eindeckung.Values.Lamelle) || false) as boolean,
    solar: (glassDensity === isForbiddenValues(Keys.Eindeckung.Values.Solar) ||
      false) as boolean,
  }

  const defaultRoofCoverings =
    !roofCoverings.lamellen && !roofCoverings.trapez && !roofCoverings.welle

  const roofLogAmount = (useSelectedNumberByVariableKey('roofLogAmount') ||
    0) as number

  return {
    color,
    glassDensity,
    dockTile,
    ledLight,
    ledLightColor,
    opacity,
    roughness,
    roofGlassDepth,
    unit,
    slatAngle,
    slatMoveIn,
    metalColor,
    glasColor,
    roofCoverings,
    defaultRoofCoverings,
    roofLogAmount,
    amplitude,
    frequenz,
    roofMarqueeMetalColor,
  }
}
